import { ref } from "vue";
import { defineStore } from "pinia";
import useLocalStorage from "@/composables/storage/useLocalStorage.js";
import filters from "@/composables/store/filters";

const { bindLocalStorage } = useLocalStorage();
const { formHasErrors, getErrorByField } = filters();

const formObject = ref({
  documentType: {
    value: null,
    required: true,
    error: "",
  },
  documentNumber: {
    value: null,
    required: true,
    error: "",
  }
});

export const useDocumentNumberStore = defineStore({
  id: "documentNumberStore",
  state: () => ({
    form: formObject,
  }),
  getters: {
    formHasErrors: (store) => formHasErrors(store),
    getErrorByField: (store) => (field) => getErrorByField(store)(field),
  },
  actions: {
    updateValue(field, val) {
      if (!Object.getOwnPropertyDescriptor(this.form, field)) {
        return;
      }

      if (Object.getOwnPropertyDescriptor(this.form[field], "validator")) {
        const { validator } = this.form[field];
        this.form[field].error = validator(field, val);
      }
      this.form[field].value = val;
      bindLocalStorage(this.$id, this.form);
    },
    updateRequiredFieldForKey(field, isRequired) {
      if (
        !field ||
        !Object.getOwnPropertyDescriptor(this.form, field) ||
        !Object.getOwnPropertyDescriptor(this.form[field], "required")
      ) {
        return;
      }

      this.form[field].required = isRequired;
    },
  },
});
